validateEmail = function(email){
	var er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);	

	if(typeof(email) == "string"){		

		if(er.test(email)){ 
			return true; 
		}	
	}else if(typeof(email) == "object"){	
		if(er.test(email.value)){ 				
			return true; 		
		}	
	}else{	
		return false;	
	}

}


// WEBPACK FOOTER //
// ./resources/assets/js/components/util/Email.js